<template>
    <section>
        <el-card shadow="never">
            <div class="top-bar" style="display:flex">
                <el-button  class="top-btn" type="success" plain @click="dialog=true;getSales()"  >添加</el-button >
                <div style="flex:1"></div>
                <el-input placeholder="输入商品名称查询" v-model="value" @change="search()" style="width:210px;margin-right:20px;" clearable>
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-select v-model="searchClassId" clearable @change="searchClass()" placeholder="主题分类查询" style="margin-right:25px">
                  <el-option v-for="(it, index) in classify" :key="index" :value="it.id" :label="it.title"></el-option>
                </el-select>
                <!-- <el-button  class="top-btn" type="danger"  plain @click="handleBatch">  移除</el-button > -->
            </div>
            <el-table :data="tableData"  @selection-change="handleChecked" max-height="510"  ref="table"  style="width: 100%">
                <!-- <el-table-column type="selection"   width="80"          align="center"> </el-table-column> -->
                <el-table-column    label="商品图片"  align="center" >
                  <template slot-scope="scope">
                    <m-img v-if="scope.row.goods_pic_url" :src="scope.row.goods_pic_url" />
                  </template>
                </el-table-column>
                <el-table-column  prop="name" label="商品名称" align="center"  show-overflow-tooltip></el-table-column>
                <el-table-column prop="section_type_id"  align="center" label="主题分类" >
                    <template slot-scope="scope" v-if="scope.row.special_column_type">{{scope.row.special_column_type.title}}</template>
                </el-table-column>
                <el-table-column prop="sort"    label="排序"    align="center" >
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.sort" @change="handleSort(scope.row)" size="mini" ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="total_price"  align="center" label="商品原价">
                  <template slot-scope="scope">
                    <span v-if="scope.row.max_price == scope.row.min_price">
                      C${{(scope.row.max_price*1).toFixed(2)}}
                    </span>
                    <span v-else>
                      C${{(scope.row.min_price*1).toFixed(2)}}~C${{(scope.row.max_price*1).toFixed(2)}}
                    </span>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  prop="Stock"
                  label="库存"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column> -->
                <el-table-column prop="total_price"  align="center" label="折后价格" v-if="section == 5">
                    <template slot-scope="scope" v-if="scope.row.special_column_type">
                      <span v-if="scope.row.max_price == scope.row.min_price">
                        C${{(scope.row.max_price * scope.row.special_column_type.off / 100).toFixed(2)}}
                      </span>
                      <span v-else>
                         C${{(scope.row.min_price * scope.row.special_column_type.off / 100).toFixed(2)}}~C${{(scope.row.max_price * scope.row.special_column_type.off / 100).toFixed(2)}}
                      </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="编辑">
                    <template slot-scope="scope" >
                        <el-button  size="mini" type="danger" plain @click="handleDel(scope.row, scope.$index)">移除</el-button >
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper"  style="padding:10px" :total="total" :page-size="size"  @current-change="loadMore"></el-pagination>
        </el-card>
        

    <!-- 修改角色的弹框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialog"
      :show-close="false"
      width="1000px"
      center
    >
      <el-card shadow="never">
        <div class="top-bar">
          <el-input
            v-model="goodsSearch"
            @change="searchGoods()"
            clearable
            placeholder="搜索商品"
            prefix-icon="el-icon-search"
            style="margin-right: 20px; width: 180px;"
          ></el-input>
          <el-select
            v-model="selectClassId"
            placeholder="选择主题分类"
            style="margin-right: 20px; width: 180px"
          >
            <el-option
              v-for="(it, index) in classify"
              :key="index"
              :value="it.id"
              :label="it.title"
            ></el-option>
          </el-select>
          <!-- <el-button  class="top-btn" type="success" plain @click="handleShow" >添加</el-button > -->
        </div>
        <el-table
          :data="goodsData"
          @selection-change="handleChecked"
          max-height="450"
          ref="table"
          style="width: 100%"
        >
          <el-table-column label="商品图片" align="center">
            <template slot-scope="scope">
              <m-img :src="scope.row.pic_image.url"></m-img>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="商品名称"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="min_price,max_price"
            align="center"
            label="价格"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="scope.row.max_price == scope.row.min_price">
                C${{ scope.row.min_price }}
              </div>
              <div v-else>
                C${{ scope.row.min_price }} - C${{ scope.row.max_price }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="off"
            label="是否折扣商品"
            align="center"
            show-overflow-tooltip
          >
          <template slot-scope="scope">
            <span> 
              {{scope.row.off?'是':'否'}}
            </span>
          </template>
          </el-table-column>
          <!-- <el-table-column
            prop="Stock.stock_num"
            label="库存"
            align="center"
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column align="center" label="编辑">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                plain
                @click="handleAdd(scope.row)"
                >添加</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          style="padding: 10px"
          :total="goodsTotal"
          :page-size="goodsSize"
          @current-change="goodsMore"
        ></el-pagination>
      </el-card>
    </el-dialog>
  </section>
</template>


<script>
import {
  section,
  section_add,
  section_put,
  section_del,
  classify_list,
} from "@/api/market.js";
import { goods_list  } from "@/api/goods.js";
import MImg from "@/components/Image";

export default {
  components: { MImg },
  props: ["section", "classify"],
  data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      size: 50,
      scrollTop: null,
      value: "",
      searchClassId: "",
      selectClassId: "",
      ids: [], // table 选中数据的 id 数组集合
      dialog: false, // 控制显示 添加修改弹窗
      dialogTitle: "添加商品",
      id: "", //  有id 是修改  没有id是添加
      sort: 1,

      // 上架商品数据
      goodsTable: [],
      goodsTotal: 0,
      goodsSize: 20,
      goodsPage: 1,
      goodsSearch: "",
    };
  },
  methods: {
    // 主题商品列表
    getData() {
      let params = {
        cid: this.section,
        page: this.page,
      };
      if (this.value != "") {
        params.search = this.value;
      }
      if (this.searchClassId != "") {
        params.type_id = this.searchClassId;
      }
      section(params).then((res) => {
        if (res) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.size = res.data.per_page
        } else {
          this.tableData = [];
        }
      });
    },
    search() {
      this.searchClassId = "";
      this.page = 1;
      this.getData();
    },
    searchClass() {
      this.value = "";
      this.page = 1;
      this.getData();
    },
    loadMore(page) {
      this.page = page;
      this.getData();
      this.scrollTop = 0;
      this.saveScroll();
    },
    // 记录滚动条的位置
    saveScroll() {
      let scrollTop = this.$el.querySelector(".el-table__body-wrapper");
      scrollTop.scrollTop = this.scrollTop;
    },
    // 修改排序
    handleSort(row){
        let params = {
          sort:row.sort
        }
        section_put(row.id,params).then(res => {
          if(res){
              this.$message({type:'success',message:res.msg,duration:1500})
              this.tableData = this.$.sortBy(this.tableData, (it) => {
                return -it.sort
              })
          }
        })
    },
    // 获取上架商品
    getSales() {
      let params = {
        page: this.goodsPage,
        status: 1,
      };
      if (this.goodsSearch != "") {
        params.search = this.goodsSearch;
      }
      goods_list(params).then((res) => {
        if (res) {
          this.goodsData = res.data.data;
          this.goodsData.forEach(item => {
            item.pic_image = {
              url: item.image_url,
              id: item.image
            }
          })
          this.goodsTotal = res.data.total;
          this.goodsSize = res.data.per_page;
        } else {
          this.goodsData = []
        }
        this.$forceUpdate();
      });
    },
    goodsMore(page) {
      this.goodsPage = page;
      this.getSales();
    },

    // 搜索上架商品
    searchGoods() {
      this.goodsPage = 1;
      this.getSales();
    },

    // 获取分类数据
    getClass() {
      let params = {
        cid: this.section,
      };
      classify_list(params).then((res) => {
        if (res) {
          this.classify = res.data;
        } else {
          this.classify = [];
        }
      });
    },
    // 添加商品函数
    handleAdd(row) {
      if (this.selectClassId == "") {
        this.$message({ type: "error", message: "请先选择分类" });
        return false;
      }
      let params = {
        cid: this.section,
        goods_id: row.id,
        tid: this.selectClassId,
      };
      if (this.section == 5) {
        this.classify.forEach((e) => {
          if (e.id == this.selectClassId) {
            params.off = e.off;
          }
        });
      }
      section_add(params).then((res) => {
        if (res) {
          // this.dialog = false
          this.getData();
          this.$message({ type: "success", message: res.msg, duration: 1500 });
        }
      });
    },

    // 点击删除
    handleDel(row, index) {
      let params = {}
      if(this.section == 5) {
        params.goods_id = row.goods_id
      }
      this.$confirm(`此操作将移除商品： ${row.name}, 是否继续?`, "提示", {
        type: "error",
      })
        .then(() => {
          section_del(row.id, params).then((res) => {
            if (res) {
              this.$message({
                type: "success",
                message: res.msg,
                duration: 1500,
              });
              this.tableData.splice(index, 1);
            }
          });
        })
        .catch(() => {});
    },
    // 监听 table 选中事件，获取选中数据的id
    handleChecked(rows) {
      rows.forEach((e) => {
        this.ids.push(e.id);
      });
    },
    // 批量删除
    handleBatch() {
      if (this.ids.length == 0) {
        this.$message({
          type: "error",
          message: "请至少选中一条数据进行批量操作哦",
        });
        return false;
      }
      this.$confirm(`此操作将删除所有选中的分类, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {})
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  created() {
    this.getData();
    this.getClass();
  },
  activated() {
    this.getData();
    this.saveScroll();
    this.getClass();
  },
    mounted() {
    // 监听滚动条的位置
    this.$refs.table.bodyWrapper.addEventListener(
      "scroll",
      (res) => {
        // let height = res.target;
        this.scrollTop = res.target.scrollTop;
      },
      false
    );
  },
  beforeDestroy() {
    this.$refs.table.bodyWrapper.removeEventListener(
      "scroll",
      (res) => {
        // let height = res.target;
        this.scrollTop = res.target.scrollTop;
      },
      false
    );
  },
};
</script>

<style lang="less" scoped>
section {
  .outside-bar {
    overflow: auto;
    zoom: 1;
  }
  .top-btn {
    width: 80px;
    margin-right: 15px;
  }
  .line-item {
    margin-bottom: 20px;
  }
  .input-left {
    height: 40px;
    line-height: 40px;
  }
  /deep/  .el-input--mini .el-input__inner  {
        text-align: center;
        width: 80px;
  } 
}
</style>